import type { ApiResult } from "@utils/httpClientCore";
import { createUnexpectedErrorMessage } from "@utils/requestUtils";

class CannotHandleErrorHereException extends Error {
  constructor(message: string) {
    super(message);
  }
}

export function cannotHandleErrorHere(response: ApiResult): asserts response is { kind: "success" };
export function cannotHandleErrorHere<T>(response: ApiResult<T>): asserts response is { kind: "success"; data: T };

export function cannotHandleErrorHere<T>(response: ApiResult<T>): asserts response is { kind: "success"; data: T } {
  if (response.kind === "error") {
    throw new CannotHandleErrorHereException(createUnexpectedErrorMessage(response.errorMessage ?? undefined, response.errorCode));
  }
}
